const FLAG_ON = '1'

/** Флаг в localStorage. Хранилище может быть закрыто (приватное окно, запрет) —
 *  тогда флаг считается снятым, а не падает. */
export function readStorageFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === FLAG_ON
  } catch {
    return false
  }
}

/** Ставит флаг; без хранилища молча ничего не делает. */
export function writeStorageFlag(key: string): void {
  try {
    localStorage.setItem(key, FLAG_ON)
  } catch {
    // без хранилища флаг не запомнится — вызывающий решает, что с этим делать
  }
}

/** Флаг в sessionStorage: живёт, пока открыта вкладка (перезагрузка его не сбрасывает,
 *  новая вкладка — не видит). Не падает без хранилища: флаг считается снятым. */
export function readSessionFlag(key: string): boolean {
  try {
    return sessionStorage.getItem(key) === FLAG_ON
  } catch {
    return false
  }
}

/** Ставит флаг вкладки; без хранилища молча ничего не делает. */
export function writeSessionFlag(key: string): void {
  try {
    sessionStorage.setItem(key, FLAG_ON)
  } catch {
    // без хранилища флаг не запомнится — вызывающий держит копию в состоянии
  }
}
